/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';

/**
 * 
 * @export
 * @interface GetManualTestDto
 */
export interface GetManualTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetManualTestDto
     */
    id: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetManualTestDto
     */
    test?: GetTestDto | null;
}

/**
 * Check if a given object implements the GetManualTestDto interface.
 */
export function instanceOfGetManualTestDto(value: object): value is GetManualTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetManualTestDtoFromJSON(json: any): GetManualTestDto {
    return GetManualTestDtoFromJSONTyped(json, false);
}

export function GetManualTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetManualTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
    };
}

export function GetManualTestDtoToJSON(value?: GetManualTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'test': GetTestDtoToJSON(value['test']),
    };
}

